<template>
  <div class="tooltip">
    <time
      class="cursor-pointer text-avtalat-secondary"
      v-on:click="props.onClickArende(arende)"
      :datetime="formatStandardDate(arende.updatedAt)"
    >
      <u>{{ formatStandardDate(arende.updatedAt) }}</u></time
    >
    <span>
      -
      {{
        arende.kontaktorsakId
          ? configStore.getKontaktorsakById(arende.kontaktorsakId)?.namn
          : arende.rubrik
      }}</span
    >
    <InternalNotePopup
      class="tooltiptext"
      v-if="arende.internaKommentarer?.length"
      :id="arende.id!"
      :internKommentar="arende.internaKommentarer[arende.internaKommentarer.length - 1]!"
    />
  </div>
</template>

<script setup lang="ts">
import type { Anstalldarende } from "@/composables/KundserviceAppApiClient";
import { useConfigStore } from "@/stores/configStore";
import { formatStandardDate } from "@/common/formatters";

import InternalNotePopup from "./InternKommentarPopup.vue";

const configStore = useConfigStore();

const props = defineProps<{
  arende: Anstalldarende;
  onClickArende: (arende: Anstalldarende) => void;
}>();
</script>

<style>
.tooltip {
  display: inline-block;
  position: relative;
}

.tooltip .tooltiptext {
  position: absolute;
  visibility: hidden;
  z-index: 1;
  box-shadow: 2px 3px 5px #d1d0d0;
  border-radius: 2px;
  background-color: white;
  padding: 10px;
  width: 400px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
